var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("Nothing here")]),_c('p'),_c('router-link',{attrs:{"to":"/"}},[_c('span',{staticClass:"text-primary"},[_vm._v("Home")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }